import { fromFetch } from 'rxjs/fetch';
import { getBuildablePlanSummaryCards } from 'constants/routes';

/**
 * Parses the fetch response into JSON.
 * Throws on non-2xx responses so the observable errors.
 *
 * NOTE:
 * - Consumers are responsible for handling errors (e.g. catchError, retry).
 */
const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};

/**
 * Fetches buildable plan summary card data for a given community.
 *
 * Uses RxJS `fromFetch` so callers can compose it with other observables.
 * Network and JSON parsing errors are propagated to the caller's observable
 * pipeline; callers are responsible for handling them (e.g. with `catchError`).
 * @param {number|string} communityId - The community to query.
 * @param {number|string} [marketId]  - Optional market filter.
 * @returns {Observable<Object>} Observable emitting the parsed JSON response.
 */
const getBuildablePlanSummaryCardsInformation = (communityId, marketId) => {
  const params = new URLSearchParams();
  params.append('communityId', communityId);

  if (marketId) {
    params.append('marketId', marketId);
  }

  const url = `${getBuildablePlanSummaryCards}?${params.toString()}`;

  return fromFetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
    selector: parseJsonResponse,
  });
};

export default getBuildablePlanSummaryCardsInformation;